// Services
import localStorageService from '../../utils/services/localStorage/localStorage';

const getWelcomeMessageBoardKey = (boardId) => `milanote.board.${boardId}.viewed_welcome`;

export const getBoardWelcomeMessageSeen = (boardId, isPublishPreview) =>
    isPublishPreview
        ? window.sessionStorage?.getItem(getWelcomeMessageBoardKey(boardId))
        : localStorageService.getItem(getWelcomeMessageBoardKey(boardId));
export const setBoardWelcomeMessageSeen = (boardId, isPublishPreview) =>
    isPublishPreview
        ? window.sessionStorage?.setItem(getWelcomeMessageBoardKey(boardId), true)
        : localStorageService.setItem(getWelcomeMessageBoardKey(boardId), true);
